import gql from 'graphql-tag';

export const APP_DOWNLOAD_BANNER_QUERY = gql`
  query AppDownloadBannerQuery(
    $deviceOS: String!
    $deviceOSVersion: String!
    $deviceType: DeviceType!
    $isMobile: Boolean!
    $nonce: String!
    $flow: String
  ) {
    appDownloadBanner(
      deviceOS: $deviceOS
      deviceOSVersion: $deviceOSVersion
      deviceType: $deviceType
      isMobile: $isMobile
      nonce: $nonce
      flow: $flow
    ) {
      __typename
      css
      html
      js
    }
  }
`;
